import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal', 'qrImage'];
  static values = {
    id: String,
  };

  connect() {
    if (
      this.hasIdValue &&
      this.modalTarget &&
      !this.modalTarget.hasAttribute('open')
    ) {
      this.modalTarget.showModal();

      // Prevent focus on buttons by focusing on dialog first
      setTimeout(() => {
        this.modalTarget.focus();
      }, 50);
    }
  }

  close() {
    if (this.modalTarget) {
      this.modalTarget.close();
    }
  }
}
